import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import dp from "../../Assets/profile-pic-1.png";
import dp from "../../Assets/Jeevi2.jpg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import Tilt from "react-parallax-tilt";
import Lottie from "react-lottie";
import Github from "../About/Github";
import Techstack from "../About/Techstack";
import Aboutcard from "../About/AboutCard";
import animationData from "../../Assets/about-me.json";
import Toolstack from "../About/Toolstack";

function Home() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  😇
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> JEEVITTAN KRISHNAN</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <Tilt>
                <img src={dp} className="img-fluid" alt="avatar" />
              </Tilt>
            </Col>
          </Row>
        </Container>
      </Container>
      {/* <Home2 /> */}
      <Container className="about-section">
        <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
          Intro About{" "}
          <strong className="purple">
            Jeevi
            <span className="wave" role="img" aria-labelledby="wave">
              😎
            </span>
          </strong>
        </h1>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{
              paddingTop: "40px",
              paddingBottom: "50px",
            }}
            className="about-img"
          >
            <Lottie options={defaultOptions} height={400} width={400} />
          </Col>
        </Row>
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
          <span className="wave" role="img" aria-labelledby="wave">
            😲
          </span>
        </h1>
        <ul>
          <li className="skills-activity">
            🔥Experienced in Building responsive web pages using React Framework
            with an Restful API.
          </li>
          <li className="skills-activity">
            🔥Experienced in using tool such as MongoDB, Swagger & ThunderClient
            for the Backend operations.
          </li>
          <li className="skills-activity">
            🔥Worked as a FrontEnd Developer in Telebort Technologies, fluent
            with library such as MUI, JS, TS & React Query.
          </li>
        </ul>

        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use{" "}
          <span className="wave" role="img" aria-labelledby="wave">
            🔥
          </span>
        </h1>
        <ul>
          <li className="skills-activity">
            🔥I use tools such as linux in projects related to CyberSecurity and
            IoT.
          </li>
          <li className="skills-activity">
            🔥Have experience using VSCode IDE and Github, Bitbucket as Version
            Control tool.
          </li>
          <li className="skills-activity">
            🔥I'm also fluent with Mockups software such as Figma, Miro, Adobe
            Illustrator, Premiere Pro etc which is used in creating UI.
          </li>
        </ul>
        <Toolstack />

        {/* <Github /> */}
      </Container>
    </section>
  );
}

export default Home;
